import { render, staticRenderFns } from "./ModalDetailPesertaSertifikasi.vue?vue&type=template&id=8114cd9e&"
import script from "./ModalDetailPesertaSertifikasi.vue?vue&type=script&lang=js&"
export * from "./ModalDetailPesertaSertifikasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports